var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indicator_tab d-flex flex-column align-items-center",class:{ selected: _vm.selected }},[_c('img',{staticClass:"i_mtb_sm_2 i_mlr_sm_3",attrs:{"src":_vm.tabContent.ProductIcon}}),_c('h5',{staticClass:"text-center i_mt_2 i_mt_sm_0"},[_vm._v(_vm._s(_vm.tabContent.ProductNickName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }